import { PaperSizeEnums } from 'src/app/enum/paper-size-enums';
import { FormatDetailModel } from './format-detail.model';
export class FormatModel {
  formatId: number = 0;
  companyId: number = 0;
  code: number = 0;
  name: string = '';
  head: number = 0;
  body: number = 0;
  foot: number = 0;
  group: boolean = false;
  paperSizeId: number = PaperSizeEnums.letter;

  formatDetails: Array<FormatDetailModel> = new Array<FormatDetailModel>();
}